import {Email, Lang, PersonId} from "@/sdk.ts";

export interface GetPerson {
  public_id: PersonId;
  email: Email; // NOTE : Is editable until account is verified
  lang?: Lang;
  is_verified: boolean;
}

export default class Person {
  readonly public_id: PersonId;
  email: Email;
  lang?: Lang;
  is_verified: boolean;

  constructor(props: GetPerson) {
    this.public_id = props.public_id;
    this.email = props.email;
    this.lang = props.lang;
    this.is_verified = props.is_verified;
  }
}
